var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "bg-white p-4" },
    [
      _c(
        "LoadingOverlay",
        { attrs: { loading: _vm.isActivitiesLoaded, hasData: !_vm.isLoading } },
        [
          _c(
            "div",
            {
              staticClass:
                "flex justify-between pt-3 pb-8 pl-2 filter-navigation",
            },
            [
              _c(
                "div",
                { staticClass: "w-fit" },
                [
                  _c("RadioButtonGroup", {
                    attrs: { options: _vm.listFilteringConditions() },
                    model: {
                      value: _vm.listFilteringCurrentCondition,
                      callback: function ($$v) {
                        _vm.listFilteringCurrentCondition = $$v
                      },
                      expression: "listFilteringCurrentCondition",
                    },
                  }),
                ],
                1
              ),
              !_vm.projectCompleted
                ? _c("UiButton", {
                    attrs: {
                      variant: "outline-black",
                      buttonText: "Create Visit",
                      buttonClasses: "px-2 pr-5 pl-3.5 mt-2 mx-2",
                    },
                    on: { click: _vm.openActivityModal },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "icon",
                          fn: function () {
                            return [_c("PlusIcon", { staticClass: "w-4 h-4" })]
                          },
                          proxy: true,
                        },
                        {
                          key: "hover-icon",
                          fn: function () {
                            return [_c("PlusIcon", { staticClass: "w-4 h-4" })]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      3411302018
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "LoadingOverlay",
                { attrs: { loading: _vm.isLoading, hasData: !_vm.isLoading } },
                [
                  _vm.listFilteringCurrentCondition === "All"
                    ? _c(
                        "div",
                        [
                          _c("CurrentVisits", {
                            attrs: {
                              userRole: _vm.userRole,
                              currentUser: _vm.currentUser,
                              companyId: _vm.companyId,
                              project: _vm.project,
                            },
                            on: {
                              activityListChanged:
                                _vm.onActivityListItemsChanged,
                            },
                          }),
                          _c("DraftVisits", {
                            attrs: {
                              userRole: _vm.userRole,
                              currentUser: _vm.currentUser,
                              companyId: _vm.companyId,
                            },
                            on: {
                              activityListChanged:
                                _vm.onActivityListItemsChanged,
                            },
                          }),
                          _c("CompletedVisits", {
                            attrs: {
                              userRole: _vm.userRole,
                              currentUser: _vm.currentUser,
                              companyId: _vm.companyId,
                              project: _vm.project,
                            },
                            on: {
                              activityListChanged:
                                _vm.onActivityListItemsChanged,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm.listFilteringCurrentCondition === "Current"
                    ? _c("CurrentVisits", {
                        attrs: {
                          currentUser: _vm.currentUser,
                          companyId: _vm.companyId,
                          project: _vm.project,
                        },
                      })
                    : _vm.listFilteringCurrentCondition === "Draft"
                    ? _c("DraftVisits", {
                        attrs: {
                          currentUser: _vm.currentUser,
                          companyId: _vm.companyId,
                        },
                      })
                    : _vm.listFilteringCurrentCondition === "Completed"
                    ? _c("CompletedVisits", {
                        attrs: {
                          currentUser: _vm.currentUser,
                          companyId: _vm.companyId,
                          project: _vm.project,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm.activityModalOpened
            ? _c("ActivityFormModal", {
                attrs: {
                  project: _vm.project,
                  currentUser: _vm.currentUser,
                  currentUserRole: _vm.userRole,
                  companyId: _vm.companyId,
                  currentUserId: _vm.currentUser.id,
                },
                on: {
                  activityAdded: _vm.onActivityListItemAdded,
                  close: function ($event) {
                    _vm.activityModalOpened = false
                  },
                },
                model: {
                  value: _vm.activityModalOpened,
                  callback: function ($$v) {
                    _vm.activityModalOpened = $$v
                  },
                  expression: "activityModalOpened",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }